const SOURCE_SELECTOR = '#custom__md-footer-selector-block .md-footer-selector__selector';
const SLOT_SELECTOR = '[data-orbe-slot-3dids]';

function closeDrawer(event) {
  const drawer = event.currentTarget.closest('header-drawer');
  if (drawer && typeof drawer.close === 'function') drawer.close();
}

function fillSlots() {
  const source = document.querySelector(SOURCE_SELECTOR);
  if (!source) return;

  for (const slot of document.querySelectorAll(SLOT_SELECTOR)) {
    if (slot.childElementCount > 0) continue;

    const button = source.cloneNode(true);
    button.removeAttribute('id');
    button.classList.add('menu-drawer__orbe-button-3dids');
    button.addEventListener('click', closeDrawer, { capture: true });
    slot.append(button);

    const row = slot.closest('.menu-drawer__orbe-3dids');
    if (row) row.hidden = false;
  }
}

if (!window.__drawerOrbe3dids) {
  window.__drawerOrbe3dids = true;

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fillSlots();
    });
  };

  fillSlots();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
}
